import React, { FC } from 'react';

// components
import ComponentTypesIconWrapper from '../../../../components/componentTypesIcon/ComponentTypesIconWrapper';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// models
import {
    ComponentType,
    ComponentTypeMapped,
} from '../../../../models/component-types-model';

interface HoveredComponentDataProps {
    componentType: ComponentType;
}

const HoveredComponentData: FC<
    React.PropsWithChildren<HoveredComponentDataProps>
> = ({ componentType }) => {
    return (
        <ComponentInfo>
            <ComponentName color={componentType.base_color}>
                <ComponentTypesIconWrapper
                    dataKey={(componentType as ComponentTypeMapped)?.data_key}
                />
                {componentType.name}
            </ComponentName>
            <Description>{componentType.description}</Description>
        </ComponentInfo>
    );
};

const ComponentInfo = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
}));

const ComponentName = styled.div((props) => ({
    color: props.color,
    fontSize: '14px',
    fontWeight: 500,
    display: 'flex',
    gap: aampeTheme.spacing(1),
    alignItems: 'center',
}));

const Description = styled.p(() => ({
    color: aampeTheme.colors.gray800,
    fontSize: '12px',
}));

export default HoveredComponentData;
